/**
 * Enum per la visibilità dei campi nella tabella degli Elenchi.
 */
export const RegisterRecordFieldVisibility = {
  BO: 'flVisibileBackofficeColonne',
  FO: 'flVisibileFrontoffice',
} as const;

export type RegisterRecordFieldVisibility =
  (typeof RegisterRecordFieldVisibility)[keyof typeof RegisterRecordFieldVisibility];
